<template>
  <div class="button-div">
    <div class="div-chexbox-button">
      <ListMenuWithCheckbox
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          (showLineMenu || showLineMenuHover)
        "
        :categories="categories"
        delay="200"
        :title="$t('general__view__lines')"
        @onChecklistToggle="onChecklistToggle"
        @onHoverListMenu="$emit('onHoverListMenu')"
        @closeHoverListMenu="$emit('closeHoverListMenu')"
      />
      <ButtonSquareHoverChecklist
        :title="$t('general__view__lines')"
        :imgSource="iconLine"
        size="large"
        style="padding-top: 24px"
        :activeState="lineActiveState"
        @clicked="toggleVisible"
        @hovered="$emit('MapLineButtonHovered')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useGeneralStore } from '@/pinia'
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import ListMenuWithCheckbox from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import iconLine from '@/assets/icon-line.svg'

// Props and emits
const props = defineProps<{
  categories: Array<any>
  showLineMenuHover: boolean
  title: string
}>()
const emit = defineEmits([
  'MapLineButtonHovered',
  'onHoverListMenu',
  'onChecklistToggle',
  'closeHoverListMenu'
])

// Vuex and Pinia stores
const store = useStore()
const piniaStore = useGeneralStore()

// State
const clickedItemType = computed(() => store.state.clickedItemType)
const showLineMenu = computed(() => piniaStore.showLineMenu)

// Compute lineActiveState
const lineActiveState = computed(() => {
  if (!props.categories.length) {
    piniaStore.setShowLineMenu(false)
    return 'deactivated'
  }
  if (showLineMenu.value) {
    return 'active'
  } else {
    return 'inactive'
  }
})

// Toggle visibility of line menu
function toggleVisible() {
  if (lineActiveState.value === 'deactivated') return
  piniaStore.setShowLineMenu(!showLineMenu.value)
}

// Checklist toggle handler
function onChecklistToggle(typeId: string, categoryId: string, checked: boolean) {
  emit('onChecklistToggle', typeId, categoryId, checked)
}
function hideHoverButtons() {
  piniaStore.setShowLineMenu(false)
}

defineExpose({
  hideHoverButtons
})
</script>

<style lang="scss" scoped>
.div-chexbox-button {
  display: flex;
  justify-content: center;
}
</style>
